import { createAction } from 'redux-actions';

export const fetchFixedFeeProfitabilityReport = createAction('FETCH_FIXED_FEE_PROFITABILITY_REPORT');
export const fetchFixedFeeProfitabilityReportSuccess = createAction('FETCH_FIXED_FEE_PROFITABILITY_REPORT_SUCCESS');
